import React from "react";

import avalanche from "../../../../assets/images/blockchain/logos/avalanche.png";
import corda from "../../../../assets/images/blockchain/logos/corda.png";
import ethereum from "../../../../assets/images/blockchain/logos/ethereum.png";
import gnosis from "../../../../assets/images/blockchain/logos/gnosis.png";
import hedera from "../../../../assets/images/blockchain/logos/hedera.png";
import hyperledger from "../../../../assets/images/blockchain/logos/hyperledger.png";
import polygon from "../../../../assets/images/blockchain/logos/polygon.png";
import solana from "../../../../assets/images/blockchain/logos/solana.png";
import weavechain from "../../../../assets/images/blockchain/logos/weavechain.png";

const Icons = {
	avalanche,
	corda,
	ethereum,
	gnosis,
	hedera,
	hyperledger,
	polygon,
	solana,
	weavechain,
};

const BlockchainLogos = (props) => {
	const { icon } = props;

	return Icons[icon] ? (
		<img src={Icons[icon]} alt={`${icon}-icon`} {...props} />
	) : null;
};

export default BlockchainLogos;
